import { render, staticRenderFns } from "./EditSMSMessage.vue?vue&type=template&id=a899d72c&"
import script from "./EditSMSMessage.vue?vue&type=script&lang=js&"
export * from "./EditSMSMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports